import { CompoundFilterOption } from '@trukt/ui/CompoundFilter';
import { ORDER_STATUS_MAP } from '@trukt/portal-utils/OrderStatusMap';

const STATUS_OPTIONS: Record<keyof typeof ORDER_STATUS_MAP, CompoundFilterOption | undefined> = {
  SUBMITTED: {
    label: 'Submitted',
    value: 'submitted',
    isClearable: true,
  },
  ON_HOLD: {
    label: 'On Hold',
    value: 'on hold',
    isClearable: true,
  },
  SCHEDULED: {
    label: 'Scheduled',
    value: 'scheduled',
    isClearable: true,
  },
  PICKED_UP: {
    label: 'Picked Up',
    value: 'picked up',
    isClearable: true,
  },
  DELIVERED: {
    label: 'Delivered',
    value: 'delivered',
    isClearable: true,
  },
  CANCELED: {
    label: 'Canceled',
    value: 'canceled',
    isClearable: true,
  },
  ALL: undefined,
};

export const COMPOUND_STATUS_FILTER_BY_ORDER_STATUS: Record<keyof typeof ORDER_STATUS_MAP, any> = {
  ALL: {
    options: [
      STATUS_OPTIONS.SUBMITTED,
      STATUS_OPTIONS.ON_HOLD,
      STATUS_OPTIONS.SCHEDULED,
      STATUS_OPTIONS.PICKED_UP,
      STATUS_OPTIONS.DELIVERED,
      STATUS_OPTIONS.CANCELED,
    ],
  },
  SUBMITTED: {
    options: [{ ...STATUS_OPTIONS.SUBMITTED, isClearable: false }],
    activeIndexs: [0],
  },
  ON_HOLD: {
    options: [{ ...STATUS_OPTIONS.ON_HOLD, isClearable: false }],
    activeIndexs: [0],
  },
  SCHEDULED: {
    options: [{ ...STATUS_OPTIONS.SCHEDULED, isClearable: false }],
    activeIndexs: [0],
  },
  PICKED_UP: {
    options: [{ ...STATUS_OPTIONS.PICKED_UP, isClearable: false }],
    activeIndexs: [0],
  },
  DELIVERED: {
    options: [{ ...STATUS_OPTIONS.DELIVERED, isClearable: false }],
    activeIndexs: [0],
  },
  CANCELED: {
    options: [{ ...STATUS_OPTIONS.CANCELED, isClearable: false }],
    activeIndexs: [0],
  },
};
